import React, { useState, useEffect } from 'react';
import jwt_decode from 'jwt-decode';
import styles from './index.module.scss';
import { withRouter } from 'react-router-dom'

// Components
import { Container, Form, InputGroup, Button } from 'react-bootstrap';
import logo from '../../logo.png';
import InfoModal from '../../components/InfoModal';
import LoadingSpinner from '../../components/LoadingSpinner';

const Login = (props) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState(['Heading', 'Text Body']);
    const [loading, setLoading] = useState(false);

    const currentYear = new Date().getFullYear();

    useEffect(() => {
        // Switch to Root Path
        props.history.push('/');
    }, [props.history])


    // Message Error Setter
    const setModalErrorMessage = (title, body) => {
        setErrorMessage([title, body]);
    };

    // When enter is pressed
    const loginEnterPressed = (e) => {
        const key = e.key;
        if (key === "Enter") {
            loginHandler();
        }
    }

    // Login Handler to login users
    const loginHandler = async () => {
        // Set Loading Spinner
        setLoading(true);

        try {
            const url = process.env.REACT_APP_API_URL;
            const loginCredentials = {
                username,
                password
            };


            const request = await fetch(`${url}/auth`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(loginCredentials)
            });

            if (request.status === 200) {
                const response = await request.json();

                const { token } = response;

                // Clear the inputs
                setUsername('');
                setPassword('');

                // Save the token in the sessionStorage
                sessionStorage.setItem('auth-token', token);

                // Set the User Data
                const decodedData = jwt_decode(token)
                props.setUserData({
                    id: decodedData.id,
                    name: decodedData.name,
                    lastname: decodedData.lastname
                });



                // Set the token
                props.setToken(token);
            } else {

                setLoading(false);

                switch (request.status) {
                    case 400:
                        setModalErrorMessage('Algunos Campos estan vacios', 'Por favor rellene todos los campos.');
                        setShowModal(true);
                        break;
                    case 403:
                        setModalErrorMessage('Usuario y Contraseña Incorrectas', 'Por favor ingrese nuevamente el usuario y la contraseña.');
                        setShowModal(true);
                        break;
                    default:
                        setModalErrorMessage('Hubo un error', 'Hubo un error de conexion verifique que el servidor este disponible');
                        setShowModal(true);
                }
            }
        } catch (err) {
            setLoading(false);
            setModalErrorMessage('Hubo un error', 'Hubo un error de conexion verifique que el servidor este disponible');
            setShowModal(true);
        }
    };

    return (
        <Container className={styles.Login}>
            <Form className={styles.Form} onKeyDown={loginEnterPressed}>
                <img src={logo} alt="logo" />
                <h4>Por Favor identifíquese</h4>
                <Form.Group className={styles.FormGroup}>
                    <InputGroup>
                        <InputGroup.Prepend className={styles.Prepend}>
                            <InputGroup.Text data-username>Usuario</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control type="text" data-username value={username} onChange={(e) => setUsername(e.target.value)} autoFocus />
                    </InputGroup>
                </Form.Group>
                <Form.Group className={styles.FormGroup}>
                    <InputGroup>
                        <InputGroup.Prepend className={styles.Prepend}>
                            <InputGroup.Text data-password>Contraseña</InputGroup.Text>
                        </InputGroup.Prepend>
                        <Form.Control type="password" data-password value={password} onChange={(e) => setPassword(e.target.value)} />
                    </InputGroup>
                </Form.Group>
                <Button variant="primary" className={styles.Button} onClick={loginHandler} disabled={loading}>
                    <span>Entrar</span>
                    {loading && <LoadingSpinner size="sm" inButton />}
                </Button>
            </Form>
            <footer>Servicell @ {currentYear}</footer>
            <InfoModal
                show={showModal}
                setShow={setShowModal}
                message={errorMessage} />
        </Container>
    );
};

export default withRouter(Login);